/**
 * Individual salary input component
 * Reusable input field for salary calculations
 */

import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

const SalaryInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  icon: Icon,
  emoji,
  type = 'brut',
  size = 'normal'
}) => {
  const typeStyles = {
    brut: {
      labelClass: 'text-blue-800 bg-blue-100',
      inputClass: 'border-blue-400 bg-white/90 text-blue-900 focus:ring-blue-500 focus:border-blue-400',
    },
    net: {
      labelClass: 'text-green-800 bg-green-100',
      inputClass: 'border-green-400 bg-white/90 text-green-900 focus:ring-green-500 focus:border-green-400',
    }
  };

  const sizeStyles = {
    small: 'h-8 text-sm',
    normal: 'h-10 text-base',
    large: 'h-12 text-lg'
  };

  const currentTypeStyle = typeStyles[type];
  const inputHeight = sizeStyles[size];
  const fontWeight = size === 'normal' ? 'font-bold' : 'font-semibold';

  return (
    <div>
      <Label 
        htmlFor={id} 
        className={`text-xs font-bold flex items-center gap-1 px-2 py-1 rounded mb-1 ${currentTypeStyle.labelClass}`}
      >
        {Icon && <Icon className="w-3 h-3" />}
        {emoji} {label}
      </Label>
      <Input
        id={id}
        type="number"
        step="0.01"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`${inputHeight} transition-all duration-200 ${fontWeight} shadow-sm ${currentTypeStyle.inputClass}`}
      />
    </div>
  );
};

export default SalaryInput;